export const CONTACT_CHANNELS = /** @type {const} */ ({
  INSTAGRAM_DM: "instagram_dm",
  EMAIL: "email",
  WHATSAPP: "whatsapp",
});

export const INSTAGRAM_DM_TEMPLATES = /** @type {const} */ ({
  COLLAB_INTRO: "collab_intro",
  CAMPAIGN_BRIEF: "campaign_brief",
  FOLLOW_UP_NUDGE: "follow_up_nudge",
});

export const EMAIL_TEMPLATES = /** @type {const} */ ({
  PARTNERSHIP_PROPOSAL: "partnership_proposal",
  FOLLOW_UP_EMAIL: "follow_up_email",
});

export const FOLLOW_UP_OPTIONS = [
  // { id: "3", label: "3 days", days: 3 },
  // { id: "5", label: "5 days", days: 5 },
  // { id: "7", label: "7 days", days: 7 },
  { id: "off", label: "Off", days: null },
];

export const SCHEDULE_OPTIONS = [
  { id: "now", label: "Send now" },
  // { id: "in_1_hour", label: "In 1 hour" },
  // { id: "tomorrow_10am", label: "Tomorrow 10am" },
  // { id: "custom", label: "Custom time" },
];

function getFirstName(fullName) {
  if (!fullName) return "";
  const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
  return parts[0] ?? "";
}

export function buildInstagramTemplate({
  templateId,
  influencerName,
  brandName,
  campaignName,
}) {
  const firstName = getFirstName(influencerName) || "there";
  const brand = brandName || "our brand";
  const campaign = campaignName || "our campaign";

  switch (templateId) {
    case INSTAGRAM_DM_TEMPLATES.CAMPAIGN_BRIEF:
      return `Hi ${firstName}!\n\nFollowing up on behalf of ${brand} — we'd love to send you our campaign brief for ${campaign}.\n\nThe campaign involves 1 Instagram Reel featuring our new Vitamin C serum. We'll share all details once you confirm interest.\n\nLooking forward to working with you! ✨`;
    case INSTAGRAM_DM_TEMPLATES.FOLLOW_UP_NUDGE:
      return `Hey ${firstName}! Just checking in — did you get a chance to see my earlier message about the ${brand} collaboration?\n\nWould love to connect when you get a moment 😊`;
    case INSTAGRAM_DM_TEMPLATES.COLLAB_INTRO:
    default:
      return `Hi ${firstName},\n\nI hope this finds you well. I’m reaching out from ${brand} regarding a paid collaboration opportunity for our ${campaign} campaign on Infuber.\n\nWe’ve been following your work and believe your audience would be a strong fit.\nWe'd love to collaborate with you on an Instagram Reel.\n\nWould you be open to discussing a partnership? ✨`;
  }
}

/** Shown in the composer; real URL is substituted on copy / Open Instagram DM via {@link expandInstagramInviteForSend}. */
export const INSTAGRAM_DM_INVITE_PLACEHOLDER_BLOCK =
  "\n\nView & respond to the campaign invite on Infuber:\nInvitation link";

export function appendInstagramInvitePlaceholderToBody(baseBody) {
  const base = String(baseBody || "").replace(/\s+$/, "");
  if (!base) return `${INSTAGRAM_DM_INVITE_PLACEHOLDER_BLOCK}\n`;
  return `${base}${INSTAGRAM_DM_INVITE_PLACEHOLDER_BLOCK}\n`;
}

/** Replace visible "Invitation link" with the real Infuber URL so pasted DMs stay tappable in Instagram. */
export function expandInstagramInviteForSend(bodyText, inviteUrl) {
  const u = String(inviteUrl || "").trim();
  if (!u) return String(bodyText || "");
  let t = String(bodyText || "");
  if (t.includes(INSTAGRAM_DM_INVITE_PLACEHOLDER_BLOCK)) {
    return t.split(INSTAGRAM_DM_INVITE_PLACEHOLDER_BLOCK).join(
      `\n\nView & respond to the campaign invite on Infuber:\n${u}`
    );
  }
  if (!t.includes(u)) {
    t = `${t.replace(/\s+$/, "")}\n\nView & respond to the campaign invite on Infuber:\n${u}\n`;
  }
  return t;
}

export function buildEmailTemplate({ templateId, influencerName, brandName, campaignName, advertisingLabel, advertisingUrl }) {
  const firstName = getFirstName(influencerName) || "there";
  const brand = brandName || "Your brand";
  const campaign = campaignName || "your campaign";
  const adLabel = advertisingLabel || "";
  const adUrl = advertisingUrl || "";
  const advertisingSection =
    adUrl
      ? `Here is our advertising campaign on Infuber you can go through:\n${adLabel}\n${adUrl}\n\n`
      : "";

  switch (templateId) {
    case EMAIL_TEMPLATES.FOLLOW_UP_EMAIL:
      return {
        subject: `Following up — ${brand} x ${campaign}`,
        body: `Hi ${firstName},\n\nJust checking in on the ${campaign} collaboration we shared with you via Infuber.\n\nCampaign invitation link:\nhttps://www.infuber.com/influencer/dashboard/affiliate-dashboard\n\n${advertisingSection}If you’re still interested, you can review the invite and confirm from your Infuber dashboard.\n\nBest,\n${brand} Team`,
      };
    case EMAIL_TEMPLATES.PARTNERSHIP_PROPOSAL:
    default:
      return {
        subject: `Partnership Opportunity — ${brand} x ${firstName}`,
        body: `Hi ${firstName},\n\nI hope this finds you well. I’m reaching out from ${brand} regarding a paid collaboration opportunity for our ${campaign} campaign on Infuber.\n\nWe’ve been following your work and believe your audience would be a strong fit.\n\nCampaign invitation link:\nhttps://www.infuber.com/influencer/dashboard/affiliate-dashboard\n\n${advertisingSection}If this is of interest, we’d love to have you onboard.\n\nWarm regards,\n${brand} Team`,
      };
  }
}

